import React from 'react';

const TermsAndConditionsFrCADucatiAudi: React.FC = () => {
    return (
        <div style={{ padding: '32px' }}>
            <p
                style={{ borderBottom: '1px solid black' }}
                className='pageTitle'
            >
                <h4>Modalités et Conditions:</h4>
            </p>
            <p>
                Veuillez lire attentivement les modalités et les passer en revue
                avec le demandeur avant de soumettre la demande à Audi Finance.
            </p>
            <ol>
                <li>
                    Audi Finance peut, en tout temps et sans préavis, modifier
                    ou réviser ces modalités et conditions.
                </li>
                <li>
                    Les services financiers décrits sur le présent site sont
                    offerts seulement au Canada et peuvent ne pas être
                    disponibles dans toutes les provinces.
                </li>
                <li>
                    L&#39admissibilité à ces services financiers, sauf dans la
                    mesure prévue par la loi, est déterminée seulement par Audi
                    Finance.
                </li>
                <li>
                    Les calculs, les montants, les nombres et les renseignements
                    fournis sur ce site sont des estimations et sont donnés à
                    titre d&#39exemple. Ils ne constituent pas une offre et sont
                    sujets à changement sans préavis.
                </li>
                <li>
                    Audi Finance ne garantie pas l&#39exactitude de
                    l&#39information présentée sur le site. En visitant ce site,
                    vous convenez que Audi Finance n&#39assume aucune
                    responsabilité (découlant d&#39un contrat, d&#39un délit ou
                    autre) à l&#39égard de dommages directs, indirects,
                    accessoires, consécutifs ou particuliers résultant de
                    l&#39utilisation de ce site.
                </li>
                <li>
                    Les renseignements que vous fournissez à Audi Finance
                    peuvent ne pas être tenus sous le sceau de la
                    confidentialité. Toutefois, Audi Finance utilisera ces
                    renseignements de manière légale et à des fins légales.
                </li>
                <li>La présente demande est soumise en votre nom.</li>
            </ol>
            <p>
                <strong>RECONNAISSANCE ET CONSENTEMENT</strong>
            </p>
            <p>
                Crédit VW Canada, Inc. et Audi Finance (« Audi Finance »)
                recueille des renseignements (définis ci- dessous) afin de
                déterminer si nous concluons ou non un contrat de location ou de
                vente conditionnelle d’un véhicule automobile (le « contrat »,
                s’il y a lieu) avec vous et, si nous acceptons votre demande,
                afin de remplir et d’administrer ce contrat, ce qui nécessite de
                recueillir, stocker, utiliser, tenir à jour et communiquer les
                renseignements conformément à la politique de confidentialité
                d&#39Audi (défini ci-dessous) appropriée.
            </p>
            <p>
                Les « renseignements » désignent tous les renseignements
                personnels pertinents que nous recueillons sur vous, y compris
                des renseignements sur le crédit, l’emploi, l’assurance du
                véhicule, la situation financière, votre dossier médical si vous
                avez eu un accident, ainsi que tout autre renseignement que nous
                obtenons sur vous durant le cours de votre contrat avec nous. À
                compter de la date de la présente demande de crédit et
                jusqu&#39à ce que vous ayez acquittés toutes vos obligations aux
                termes du contrat, vous consentez à ce qu&#39Audi Finance et
                Audi Canada Inc (ci-après collectivement « Audi ») peuvent
                utiliser vos renseignements afin de vérifier votre identité
                (notamment, votre nom, date de naissance et coordonnées) et à
                des fins d’évaluation initiale et continue du crédit, y compris
                en obtenant périodiquement des rapports de solvabilité et des
                renseignements sur votre historique financier et de crédit de
                toute agence d&#39évaluation du crédit, incluant notamment
                celles mentionnées ci-dessous. Nous pourrons utiliser ces
                renseignements afin de créer des évaluations/pointage de crédit
                personnalisés de votre solvabilité, même si votre demande de
                crédit est refusée ou approuvée mais que vous ne concluez pas de
                contrat avec nous. Nous pourrons utiliser ce pointage de crédit
                personnalisé afin de déterminer si nous conclurons un contrat
                avec vous et vous accorderons du crédit. Si nous concluons un
                contrat avec vous, Audi peut également utiliser ces
                renseignements afin d&#39effectuer des suivis de l&#39assurance
                du véhicule, d’administration interne, de publication du contrat
                et droits d&#39Audi Finance et d&#39immatriculation du véhicule,
                d’administration de fin de location et de vente auprès de vous
                si vous décidez d’acheter le véhicule que vous louez, de
                garanties du véhicule, de service à la clientèle et de rappels,
                de recouvrement et pour tout autre motif exigé ou autorisé par
                la loi. Avec votre consentement, Audi peut également utiliser
                ces renseignements pendant et après la durée du contrat à des
                fins de marketing.
            </p>
            <p>Vos renseignements:</p>
            <ul>
                <li>
                    peuvent être stockés au bureau d&#39Audi Finance au 500-1340
                    Pickering Pky, Pickering, ON, L1V 0C4, au bureau du
                    concessionnaire Audi Canada autorisé mentionné ci-dessus,
                    sur des serveurs situés à l’extérieur du Canada (y compris
                    aux États-Unis et en Allemagne) si vous consentez au partage
                    de vos renseignements, au bureau d&#39Audi Canada situé au
                    777 Bayly St. West, Ajax, ON, à l&#39extérieur du Canada à
                    des fins de traitement, et peuvent être assujettis aux lois
                    de ces territoires étrangers et consultés par les autorités
                    responsables de l&#39application de la loi ou les tribunaux
                    locaux;
                </li>
                <li>
                    sont accessibles uniquement aux employés, aux sociétés
                    affiliées et aux représentants autorisés d&#39Audi et du
                    concessionnaire Audi Canada mentionné ci-dessus, dont la
                    description de poste, les tâches, les fonctions et le mandat
                    nécessitent et justifient l’accès à vos renseignements et à
                    leur utilisation;
                </li>
                <li>
                    peuvent être communiqués, transférés, stockés ou traités par
                    des fournisseurs de services tiers, des entreprises de
                    traitement des paiements, des prêteurs, des agences
                    d’évaluation du crédit, Equifax Canada Co. (Box 190, Jean
                    Talon Station, Montréal, Québec, H1S 2Z2) et Trans Union of
                    Canada Inc. ( Relation avec les consommateurs, P.O. Box 338,
                    LCD1, Hamilton, Ontario, L8L 7W2), (cela inclus de
                    communiquer un rapport négatif si vous ne respectez pas vos
                    obligations, ce qui pourrait avoir un effet néfaste sur
                    votre crédit) avec lesquelles agences vous pourrez
                    communiquer et obtenir votre rapport de crédit et le
                    rectifier, le cas échéant, ou d&#39autres entités affiliées
                    à Audi dans d&#39autres pays; et
                </li>
                <li>
                    peuvent être communiqués à des fins de financement aux
                    prêteurs d&#39Audi, à une entité qui se porte acquéreuse
                    d&#39Audi en totalité ou en partie, ou à la ou aux entités
                    qui découlent d’une restructuration d’entreprise d&#39Audi.
                </li>
            </ul>
            <p>
                Audi et ses fournisseurs de services maintiennent des normes
                élevées en matière de mesures de protection physiques,
                électroniques et procédurales en vue de protéger vos
                renseignements et conserveront ceux-ci aussi longtemps que la
                loi l’exigera ou l’autorisera.
            </p>
            <p>
                Vous avez le droit, en tout temps, d&#39accéder à vos
                renseignements ou de les corriger. Il est possible de nous
                joindre aux adresses indiquées ci-dessous.
            </p>
            <p>
                Pour obtenir de plus amples renseignements, veuillez-vous
                reporter à notre politique de confidentialité d&#39Audi Finance{' '}
                <a href='https://www.audi.ca/ca/web/fr/services-financiers.html#layer=/ca/web/fr/tools/navigation/layer/clause-de-non-responsabilite/confidentialite.html'>
                    ici
                </a>{' '}
                et à l’adresse suivante:{' '}
                <a href='https://www.audi.ca/ca/web/fr/services-financiers.html'>
                    www.audifinance.ca{' '}
                </a>
            </p>
            <p>
                Vous pouvez également trouver la politique de confidentialité
                pour Audi{' '}
                <a href='https://www.audi.ca/ca/web/fr.html#layer=/ca/web/fr/tools/navigation/layer/clause-de-non-responsabilite/confidentialite.html'>
                    ici
                </a>{' '}
                et à l’adresse suivante :{' '}
                <a href='https://www.audi.ca/ca/web/fr.html'>www.audi.ca </a>
            </p>
            <p>
                <strong>
                    <u>EN APPOSANT VOTRE SIGNATURE CI-DESSOUS, VOUS:</u>
                </strong>
            </p>
            <ol style={{ listStyleType: 'lower-roman' }}>
                <li>
                    <strong>
                        <u>
                            CONSENTEZ À CE QUE NOUS OBTENIONS UN RAPPORT DE
                            SOLVABILITÉ VOUS VISANT MAINTENANT ET À DES FINS
                            D’ÉVALUATIONS CONTINUES DU CRÉDIT, JUSQU’À CE QUE LE
                            CONTRAT SOIT PAYÉ EN TOTALITÉ ET EXÉCUTÉ DANS SON
                            INTÉGRALITÉ, ET À CE QUE NOUS PUISSIONS TRANSMETTRE
                            PÉRIODIQUEMENT VOS RENSEIGNEMENTS À DES AGENCES
                            D’ÉVALUATION DU CRÉDIT;
                        </u>
                    </strong>
                </li>
                <li>
                    <strong>
                        consentez à ce que le concessionnaire Audi Canada
                        mentionné ci-dessus partage vos renseignements avec Audi
                        Finance aux fins de l’évaluation de votre demande de
                        crédit;
                    </strong>
                </li>
                <li>
                    <strong>
                        consentez à ce qu&#39Audi Finance continue d’administrer
                        tous les contrats que vous signez dans le cadre de cette
                        demande de crédit et à ce qu&#39Audi Finance partage vos
                        renseignements raisonnablement nécessaires pour
                        administrer ces contrats;
                    </strong>
                </li>
                <li>
                    <strong>
                        déclarez et garantissez qu’aucune procédure ou
                        proposition de faillite n’existe à votre égard, et que
                        vos renseignements sont véridiques et exacts.
                    </strong>
                </li>
            </ol>
            <p>
                De plus, Audi Finance et Audi Canada souhaitent obtenir votre
                consentement pour les motifs indiqués sous les points 1 et 2 de
                la colonne « Motif » ci-dessous.
            </p>
            <p>
                Vous pouvez vous désabonner à tout moment: en composant le 1 888
                412-2834 ou en écrivant à l’adresse suivante 500-1340 Pickering
                Pky, Pickering, Ontario, L1V 0C4 Aux soins de : Agent de la
                protection de la vie privée
            </p>
            <table
                style={{
                    width: '720px',
                    border: '1px solid black',
                    borderCollapse: 'collapse',
                }}
            >
                <thead>
                    <tr>
                        <th colSpan={2} style={{ textAlign: 'center' }}>
                            <strong>CONSENTEMENT</strong>
                        </th>
                        <th style={{ textAlign: 'center' }}>
                            <strong>MOTIF</strong>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ textAlign: 'center' }}>
                            <strong>Demandeur</strong>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            <strong>Codemandeur/garant</strong>
                        </td>
                        <td rowSpan={2}>
                            <p>
                                1. À ce qu&#39Audi Finance ou Audi utilise mes
                                renseignements personnels pour m’envoyer du
                                contenu de marketing concernant de nouveaux
                                véhicules, de produits ou service, d’événements
                                et d’offres promotionnelles ou de fidélisation,
                                y compris des offres de financement ou de
                                location (« documents de marketing »).
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <label>
                                    <input type='checkbox' /> Je consens
                                </label>
                                <br />
                                <label>
                                    <input type='checkbox' /> Je ne consens pas
                                </label>
                            </p>
                        </td>
                        <td>
                            <p>
                                <label>
                                    <input type='checkbox' /> Je consens
                                </label>
                                <br />
                                <label>
                                    <input type='checkbox' /> Je ne consens pas
                                </label>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <label>
                                    <input type='checkbox' /> Je consens
                                </label>
                                <br />
                                <label>
                                    <input type='checkbox' /> Je ne consens pas
                                </label>
                            </p>
                        </td>
                        <td>
                            <p>
                                <label>
                                    <input type='checkbox' /> Je consens
                                </label>
                                <br />
                                <label>
                                    <input type='checkbox' /> Je ne consens pas
                                </label>
                            </p>
                        </td>
                        <td>
                            <p>
                                2. À recevoir des communications concernant le
                                contrat et, si vous consentez à l’énoncé
                                ci-dessus, des documents de marketing en format
                                électronique (p. ex., par courriel ou par
                                message texte).
                            </p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p>
                <strong>
                    Je conviens que j’ai eu la possibilité de lire ce document
                    Déclaration et consentement avant de le signer et que j’en
                    ai reçu une copie.{' '}
                </strong>
            </p>
            <table
                style={{
                    width: '100%',
                    border: '1px solid black',
                    borderCollapse: 'collapse',
                }}
            >
                <tbody>
                    <tr>
                        <td style={{ width: '75%' }}>
                            <p>Signature du demandeur</p>
                        </td>
                        <td style={{ width: '25%' }}>
                            <p>Date:</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Signature du codemandeur/garant</p>
                        </td>
                        <td>
                            <p>Date:</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default TermsAndConditionsFrCADucatiAudi;
